import { getReqAuth } from '../../api';

export const getSystemHealth = (cb) =>
  getReqAuth('/webapi/institute/system/health', {}, '', cb);

export const getDiskUsage = (cb) =>
  getReqAuth('/webapi/institute/system/disk-usage', {}, '', cb);

export const getMongoStats = (cb) =>
  getReqAuth('/webapi/institute/system/mongo-stats', {}, '', cb);
